import { formatDate } from '../../components/CrmForms';
import { Activity, Company, Contact } from '../../types';

export function buildContactsCsv(
  contacts: Contact[],
  companiesById: ReadonlyMap<string, Company>,
  latestActivitiesByContact: ReadonlyMap<string, Activity> = new Map(),
): string {
  const rows = [
    [
      'Contact',
      'Title',
      'Company',
      'Last activity date',
      'Last activity type',
      'Last activity subject',
      'Last activity details',
    ],
    ...contacts.map((contact) => {
      const activity = latestActivitiesByContact.get(contact.id);
      return [
        contactName(contact),
        contact.title || '',
        getCompanyName(contact, companiesById),
        formatDate(contact.lastActivityAt),
        activity?.type.replace('_', ' ') || '',
        activity?.subject.trim() || '',
        activity?.body.trim() || '',
      ];
    }),
  ];

  return rows.map((row) => row.map(csvValue).join(',')).join('\r\n');
}

function csvValue(value: string): string {
  return /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

function contactName(contact: Contact): string {
  return [contact.firstName, contact.lastName].filter(Boolean).join(' ').trim() || contact.email || 'Unnamed contact';
}

function getCompanyName(contact: Contact, companiesById: ReadonlyMap<string, Company>): string {
  return (contact.companyId ? companiesById.get(contact.companyId)?.name : null) || contact.companyName || '';
}
